/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewRewardsClaim
 */
export interface NewRewardsClaim {
    /**
     * 
     * @type {string}
     * @memberof NewRewardsClaim
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof NewRewardsClaim
     */
    lastUpdated?: Date;
    /**
     * 
     * @type {number}
     * @memberof NewRewardsClaim
     */
    courierUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewRewardsClaim
     */
    rewardPrizeId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewRewardsClaim
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewRewardsClaim interface.
 */
export function instanceOfNewRewardsClaim(value: object): value is NewRewardsClaim {
    return true;
}

export function NewRewardsClaimFromJSON(json: any): NewRewardsClaim {
    return NewRewardsClaimFromJSONTyped(json, false);
}

export function NewRewardsClaimFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewRewardsClaim {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'lastUpdated': json['lastUpdated'] == null ? undefined : (new Date(json['lastUpdated'])),
        'courierUserId': json['courierUserId'] == null ? undefined : json['courierUserId'],
        'rewardPrizeId': json['rewardPrizeId'] == null ? undefined : json['rewardPrizeId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewRewardsClaimToJSON(json: any): NewRewardsClaim {
    return NewRewardsClaimToJSONTyped(json, false);
}

export function NewRewardsClaimToJSONTyped(value?: NewRewardsClaim | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'lastUpdated': value['lastUpdated'] == null ? undefined : ((value['lastUpdated']).toISOString()),
        'courierUserId': value['courierUserId'],
        'rewardPrizeId': value['rewardPrizeId'],
        'courierId': value['courierId'],
    };
}

